function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Log from '@deephaven/log';
import { getFileStorage } from '@deephaven/redux';
import FileExplorer, { FileExplorerToolbar, FileUtils, NewItemModal, isDirectory } from '@deephaven/file-explorer';
import React from 'react';
import { connect } from 'react-redux';
import Panel from "./CorePanel.js";
import { NotebookEvent } from "../events/index.js";
import "./FileExplorerPanel.css";
import { getDashboardSessionWrapper } from "../redux/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('FileExplorerPanel');
var mapStateToProps = (state, ownProps) => {
  var fileStorage = getFileStorage(state);
  var sessionWrapper = getDashboardSessionWrapper(state, ownProps.localDashboardId);
  var _ref = sessionWrapper !== null && sessionWrapper !== void 0 ? sessionWrapper : {},
    session = _ref.session,
    sessionConfig = _ref.config;
  var language = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.type;
  return {
    fileStorage,
    language,
    session
  };
};
var connector = connect(mapStateToProps, null, null, {
  forwardRef: true
});
function isMouseEvent(e) {
  var mouseEvent = e;
  return mouseEvent != null && typeof mouseEvent.button === 'number';
}

/**
 * Panel for showing a FileExplorer in a Dashboard.
 */
export class FileExplorerPanel extends React.Component {
  static handleError(error) {
    log.error(error);
  }

  /**
   * Return true if the event should open a file and focus it, otherwise false
   * @param event The event to check
   */
  static isFocusEvent(event) {
    if (isMouseEvent(event)) {
      // If it's not a double click, then it's a preview event
      return event.detail >= 2;
    }

    // Keyboard event should always open with focus
    return true;
  }
  constructor(props) {
    super(props);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleCopyFile = this.handleCopyFile.bind(this);
    this.handleCreateFile = this.handleCreateFile.bind(this);
    this.handleCreateDirectory = this.handleCreateDirectory.bind(this);
    this.handleCreateDirectoryCancel = this.handleCreateDirectoryCancel.bind(this);
    this.handleCreateDirectorySubmit = this.handleCreateDirectorySubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleRename = this.handleRename.bind(this);
    this.handleSessionOpened = this.handleSessionOpened.bind(this);
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    var session = props.session,
      language = props.language;
    this.state = {
      isShown: false,
      language,
      session,
      showCreateFolder: false,
      focusedFilePath: '/'
    };
  }
  componentDidMount() {
    if (!this.isHidden()) {
      this.setState({
        isShown: true
      });
    }
  }
  handleCreateFile() {
    var glEventHub = this.props.glEventHub;
    var _this$state = this.state,
      session = _this$state.session,
      language = _this$state.language;
    var notebookSettings = {
      language,
      value: ''
    };
    log.debug('handleCreateFile', session, language, notebookSettings);
    glEventHub.emit(NotebookEvent.CREATE_NOTEBOOK, session, language, notebookSettings);
  }
  handleCreateDirectory() {
    this.setState({
      showCreateFolder: true
    });
  }
  handleCreateDirectoryCancel() {
    log.debug('handleCreateDirectoryCancel');
    this.setState({
      showCreateFolder: false
    });
  }
  handleCreateDirectorySubmit(path) {
    log.debug('handleCreateDirectorySubmit', path);
    this.setState({
      showCreateFolder: false
    });
    var fileStorage = this.props.fileStorage;
    fileStorage.createDirectory(path).catch(FileExplorerPanel.handleError);
  }
  handleCopyFile(file) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var fileStorage = _this.props.fileStorage;
      if (isDirectory(file)) {
        log.error('Invalid item in handleCopyItem', file);
        return;
      }
      var newName = yield FileUtils.getUniqueCopyFileName(fileStorage, file.filename);
      yield fileStorage.copyFile(file.filename, newName);
    })();
  }
  handleDelete(files) {
    var glEventHub = this.props.glEventHub;
    files.forEach(file => {
      glEventHub.emit(NotebookEvent.CLOSE_FILE, {
        id: file.filename,
        itemName: file.filename
      });
    });
  }
  handleSelectionChange(selectedItems) {
    var path = '/';
    if (selectedItems.length === 1) {
      if (selectedItems[0].type === 'directory') {
        path = FileUtils.makePath(selectedItems[0].filename);
      } else {
        path = FileUtils.getPath(selectedItems[0].filename);
      }
    }
    this.setState({
      focusedFilePath: path
    });
  }
  handleFileSelect(file, event) {
    log.debug('fileSelect', file);
    if (file.type === 'directory') {
      return;
    }
    var shouldFocus = FileExplorerPanel.isFocusEvent(event);
    var fileMetadata = {
      id: file.filename,
      itemName: file.filename
    };
    var glEventHub = this.props.glEventHub;
    var _this$state2 = this.state,
      session = _this$state2.session,
      language = _this$state2.language;
    var notebookSettings = {
      value: null,
      language
    };
    glEventHub.emit(NotebookEvent.SELECT_NOTEBOOK, session, language, notebookSettings, fileMetadata, shouldFocus);
  }
  handleRename(oldName, newName) {
    var glEventHub = this.props.glEventHub;
    log.debug('handleRename', oldName, newName);
    glEventHub.emit(NotebookEvent.RENAME_FILE, oldName, newName);
  }
  handleSessionOpened(_ref2) {
    var session = _ref2.session,
      language = _ref2.language;
    this.setState({
      session,
      language
    });
  }
  handleSessionClosed() {
    this.setState({
      session: undefined,
      language: undefined
    });
  }
  handleShow() {
    this.setState({
      isShown: true
    });
  }
  isHidden() {
    var glContainer = this.props.glContainer;
    var isHidden = glContainer.isHidden;
    return isHidden;
  }
  render() {
    var _this$props = this.props,
      fileStorage = _this$props.fileStorage,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var _this$state3 = this.state,
      isShown = _this$state3.isShown,
      showCreateFolder = _this$state3.showCreateFolder,
      focusedFilePath = _this$state3.focusedFilePath;
    return /*#__PURE__*/_jsxs(Panel, {
      className: "file-explorer-panel",
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onSessionOpen: this.handleSessionOpened,
      onSessionClose: this.handleSessionClosed,
      onShow: this.handleShow,
      children: [/*#__PURE__*/_jsx(FileExplorerToolbar, {
        createFile: this.handleCreateFile,
        createFolder: this.handleCreateDirectory
      }), isShown && /*#__PURE__*/_jsx(FileExplorer, {
        isMultiSelect: true,
        storage: fileStorage,
        onCopy: this.handleCopyFile,
        onCreateFile: this.handleCreateFile,
        onCreateFolder: this.handleCreateDirectory,
        onDelete: this.handleDelete,
        onRename: this.handleRename,
        onSelect: this.handleFileSelect,
        onSelectionChange: this.handleSelectionChange
      }), /*#__PURE__*/_jsx(NewItemModal, {
        isOpen: showCreateFolder,
        type: "directory",
        title: "Create New Folder",
        storage: fileStorage,
        onSubmit: this.handleCreateDirectorySubmit,
        onCancel: this.handleCreateDirectoryCancel,
        defaultValue: focusedFilePath
      })]
    });
  }
}
_defineProperty(FileExplorerPanel, "COMPONENT", 'FileExplorerPanel');
_defineProperty(FileExplorerPanel, "TITLE", 'File Explorer');
var ConnectedFileExplorerPanel = connector(FileExplorerPanel);
export default ConnectedFileExplorerPanel;
//# sourceMappingURL=FileExplorerPanel.js.map